import { render, staticRenderFns } from "./ModalLogsAllocation.vue?vue&type=template&id=478149bf&scoped=true"
import script from "./ModalLogsAllocation.vue?vue&type=script&lang=js"
export * from "./ModalLogsAllocation.vue?vue&type=script&lang=js"
import style0 from "./ModalLogsAllocation.vue?vue&type=style&index=0&id=478149bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478149bf",
  null
  
)

export default component.exports